export default async ({ route, store }) => {
  const customer = store.getters['user/getCustomer'];
  const jumbotronParams = {
    name: customer.fname
  };
  const jumbotronTitle = store.$i18n.t('pageInfo.compare-life-insurance.thank-you.jumbotron.title', jumbotronParams);
  route.meta[0] = { ...route.meta[0], ...{ jumbotronParams, jumbotronTitle } };
};
